const circle = document.getElementById('circle');
let sliderContainer = document.querySelector('.slider-container');
const circleStyle = circle.style;

document.addEventListener('mousemove', e => {
  window.requestAnimationFrame(() => {
    circleStyle.top = `${ e.clientY - circle.offsetHeight/2 }px`;
    circleStyle.left = `${ e.clientX - circle.offsetWidth/2 }px`;
  });
});

sliderContainer.addEventListener('mouseenter', function(){
    circle.classList.add('active');
 });

 sliderContainer.addEventListener('mouseleave', function(){
    circle.classList.remove('active');
  });